import { Input } from "@/components/ui/input";
import { useLang } from "@/lib/i18n";
import { VAGUE_TIMES, fmtTime } from "@/lib/format";

export const TimeField = ({ value, onChange, testid, required }) => {
  const { t } = useLang();
  const vague = VAGUE_TIMES.includes(value);
  return (
    <div className="flex gap-1.5 min-w-0">
      {vague ? (
        <div data-testid={`${testid}-vague`} className="h-10 flex-1 min-w-0 border border-[#C5A059]/60 bg-[#C5A059]/10 text-[#D9B872] grid place-items-center text-sm font-medium truncate">{fmtTime(value, t)}</div>
      ) : (
        <Input data-testid={testid} type="time" required={required} value={value || ""} onChange={(e) => onChange(e.target.value)} className="h-10 flex-1 min-w-0 rounded-none mono bg-white px-2" />
      )}
      <select data-testid={`${testid}-mode`} aria-label={t("time.mode")} value={vague ? value : "exact"} onChange={(e) => onChange(e.target.value === "exact" ? "" : e.target.value)}
        className="h-10 w-[6.5rem] shrink-0 border border-input bg-[#18181B] text-[#F4F1EA] px-1 text-xs focus:outline-none focus:ring-1 focus:ring-[#C5A059]">
        <option value="exact">{t("time.exact")}</option>
        <option value="AM">AM</option>
        <option value="PM">PM</option>
        <option value="TBD">{t("time.tbd")}</option>
      </select>
    </div>
  );
};
